import { EasyImg } from 'src/components'
import { mainStore } from 'enasops/stores'
import { getImgBase } from 'src/utils/axios'
import { pictureThumb } from 'src/assets/base64'
import 'enasops/styles/op/028/index.less'

export default {
  renderImg (text: string, record: any, ListTableContext: any) {
    if (!text) return null

    const url = `${mainStore.baseConfig.FileDomain || getImgBase()}${text}`
    return (
      <EasyImg
        popEnable
        defaultSrc={pictureThumb}
        src={url}
        popStyle={{ width: 180, height: 180 }}
        style={{ width: 22, height: 22, verticalAlign: 'text-top' }}
      />
    )
  }
}